import { PeriodTypes } from '../../lib/types/models/period/period'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPeriod(data: PeriodTypes.Input) {
  return restApiClient.url(constructApiUrl(API.periods.create.url, null)).post(data)
}
